import { createSelector } from '@reduxjs/toolkit';
import { selectClientPortalSettingsState } from '../../store/selectors';
import { clientPortalToggleDefinitions } from './constants';

export const selectAfsls = createSelector(selectClientPortalSettingsState, (settingsState) => settingsState.afsls);

export const selectAfslId = createSelector(selectClientPortalSettingsState, (settingsState) => settingsState.afslId);

export const selectClientPortalSetting = createSelector(selectClientPortalSettingsState, (settingsState) => settingsState.setting);

export const selectHasUnsavedChanges = createSelector(selectClientPortalSettingsState, (settingsState) =>
  clientPortalToggleDefinitions.some((definition) => settingsState.setting[definition.key] !== settingsState.savedSetting[definition.key])
);
